<e-dialog [open]="target() !== null" (openChange)="onOpenChange($event)" [title]="text().title">
  <ng-template>
    <div class="moment-save-form">
      <p class="moment-save-intro">{{ text().intro }} <strong>{{ target()?.momentText }}</strong></p>
      @if (target()?.errorText) {
        <div class="moment-save-error">{{ target()?.errorText }}</div>
      }
      <div class="moment-save-row">
        <input
          class="moment-save-input"
          type="text"
          [placeholder]="text().placeholder"
          [ngModel]="name()"
          (ngModelChange)="name.set($event)"
          (keydown.enter)="submit()"
        />
        <button eBtn color="primary-75" icon="calendar-star" [disabled]="!canSave" (click)="submit()">
          {{ text().save }}
        </button>
      </div>
    </div>
  </ng-template>
</e-dialog>
